<template>
  <div>
    <va-inner-loading :loading="loader">
      <!-- start order header -->
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center">
          <h1>Все заказы</h1>
          <va-button color="primary" :to="{ name: 'order-create' }">
            Новый заказ
          </va-button>
        </div>
      </va-card>
      <!-- end order header -->
      <orders-table
        v-if="allOrders.orders"
        class="mb-4"
        :orders="allOrders.orders"
      ></orders-table>
    </va-inner-loading>
  </div>
</template>

<script>
import ordersTable from '../../components/orders/orders-table.vue';
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  components: { ordersTable },
  computed: {
    ...mapState({
      allOrders: 'order',
    }),
    ...mapGetters({
      loader: 'isLoading',
    }),
  },
  async created() {
    await this.getOrdersActions({
      page: 1,
      is_quick_buy: 0,
      order_statuses: ["new", "in_work", "assembling", "ready", "in_delivery"],
    });
  },
  methods: {
    ...mapActions({
      getOrdersActions: 'order/getOrders',
    }),
  },
};
</script>

<style>
</style>
